export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder-img-fallback.png";